module.exports = __webpack_public_path__ + "static/media/classic-with-m-ms.fb6c2d7b.png";